import React, { useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Dialog } from "primereact/dialog";
import "./CardStyle.scss";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import areamasterimg from "../../../Assets/areamasterimg.png";
import districtMasterImg from "../../../Assets/districtMaster.png";
import villagemaster from "../../../Assets/villagemaster.png";
import bankbranchmaster from "../../../Assets/bankbranchmaster.png";
import phcmaster from "../../../Assets/phcmaster.png";
import talukamaster from "../../../Assets/Talukamaster.png";
import workCatMasterImg from "../../../Assets/workCategoriesMaster.png";
import usermaster from "../../../Assets/usermaster.png";
import userTypeMasterImg from "../../../Assets/userTypeMaster.png";
import trainingMasterImg from "../../../Assets/trainingMaster.png";
import greendot from "../../../Assets/greendot.png";
import reddot from "../../../Assets/reddot.png";
import ModalHeader from "../../../Components/Header/ModalHeader";
import PropTypes from "prop-types";
import subcenterImg from "../../../Assets/subCentreImg.png";
import trainingCalendarImg from "../../../Assets/trainingCalendarImg.png";
import facultyImg from "../../../Assets/facultyImg.png";
import activityMasterImg from "../../../Assets/activityMasterImg.png";
import MasterTypes from "../../../Shared/Constant/MastersTypes";
import MasterAddUpdateForm from "../MasterAddUpdateForm/MasterAddUpdateForm";
import { FORM_CONFIG } from "../../../Shared/Constant/MasterFormConstants";
import { MasterNames } from "../../../Shared/Constant/MasterNames";
import { useTranslation } from "react-i18next";
const Cards = ({ content = {} }) => {
  const {
    disableAddButton = false,
    masterName = "",
    showAddButton = false,
    showInvalidCount = false,
    showTotalCount = false,
    showValidCount = false,
    totalAdded = 0,
    totalInvalid = 0,
    totalValid = 0,
  } = content;
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [selectedMasterType, setSelectedMasterType] = useState(null);
  const { t } = useTranslation("master");
  const closeDialog = () => {
    setVisible(false);
  };
  const { footTxt, image, contentTxt } = fetchCardStaticData(masterName, t);

  const onClickViewMore = () => {
    handleViewMoreClick(masterName, navigate);
  };

  const onClickAddMaster = () => {
    handleAddMasterData(
      masterName,
      setVisible,
      setSelectedMasterType,
      setSelectedForm,
      navigate
    );
  };

  const header = (
    <>
      <div className="flex align-items-center justify-content-between card_head">
        <div className="pl-3 text-sm font-semibold masternameclss">
          {t(masterName)}
        </div>
        <div className="pr-3">
          <Button
            link
            onClick={onClickViewMore}
            className="viewmorfont"
            data-testid="viewMoreButton"
          >
            {" "}
            {t("ViewMore")}
          </Button>
        </div>
      </div>
      <Divider />
    </>
  );

  const disabledBtnClassName = disableAddButton ? "disabled" : "";
  const footer = showAddButton ? (
    <Button
      className={`flex align-items-center justify-content-center cursorBtnStyle h-3rem border-1 w-full customBtn bg-white
      ${disabledBtnClassName}`}
      disabled={disableAddButton}
      onClick={onClickAddMaster}
      data-testid="addMasterDataButton"
    >
      <div className="mr-2">+</div>
      <div>{footTxt}</div>
    </Button>
  ) : null;

  return (
    <div>
      <Card footer={footer} header={header} className="master-card">
        <div className="grid">
          {showTotalCount && (
            <div className="flex ">
              <div className="cardImage">{image}</div>
              <div className="ml-4">
                <div className="text-xs">{contentTxt}</div>
                <div className="text-left text-xl font-semibold">
                  {totalAdded}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="">
          <div className="col-3 flex width-auto gap-5 ml-6">
            {showValidCount && (
              <div className="flex flex-column ml-3">
                <div className="flex">
                  <img className="dotclss mt-2 mr-1" src={greendot} alt="" />
                  <div className="text-xs mt-1 ml-1">{t("Valid")}</div>
                </div>
                <div className="text-left text-xl font-semibold m-2 ml-3">
                  {totalValid}
                </div>
              </div>
            )}
            {showInvalidCount && (
              <div className="flex flex-column">
                <div className="flex">
                  <img className="dotclss mt-2 mr-1" src={reddot} alt="" />
                  <div className="text-xs mt-1 ml-1">{t("Invalid")}</div>
                </div>
                <div className="text-left text-xl font-semibold m-2 ml-3">
                  {totalInvalid}
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>
      {visible && (
        <Dialog
          className="cockpit-dialog"
          visible={visible}
          modal={true}
          position={"center"}
          draggable={false}
          resizable={false}
          onHide={() => {
            setSelectedForm(null);
            closeDialog();
          }}
          closeOnEscape={false}
          header={
            <ModalHeader onClose={closeDialog} backText={t("Back To Master")} />
          }
        >
          <MasterAddUpdateForm
            onClose={closeDialog}
            mode={"Add"}
            formConfig={selectedForm}
            masterType={selectedMasterType}
          />
        </Dialog>
      )}
    </div>
  );
};

Cards.propTypes = {
  content: PropTypes.object.isRequired,
};

export default Cards;

function fetchCardStaticData(masterName, t) {
  switch (masterName) {
    case MasterNames.AREATYPE:
      return {
        image: <img src={areamasterimg} alt="Area Type Master" />,
        contentTxt: t("TotalAddedAreaTypes"),
        footTxt: t("AddNewAreaType"),
      };
    case MasterNames.DISTRICT:
      return {
        image: <img src={districtMasterImg} alt="District Master" />,
        contentTxt: t("TotalAddedDistricts"),
        footTxt: t("AddNewDistrict"),
      };
    case MasterNames.GOVERNINGBODY:
      return {
        image: <img src={districtMasterImg} alt="Governing Body Master" />,
        contentTxt: t("TotalAddedLgb"),
        footTxt: t("AddNewGoverningBody"),
      };
    case MasterNames.CORPORATION:
      return {
        image: <img src={districtMasterImg} alt="Corporation Council Master" />,
        contentTxt: t("TotalAddedCorporation"),
        footTxt: t("AddCorporation"),
      };
    case MasterNames.VILLAGE:
      return {
        image: <img src={villagemaster} alt="Village Master" />,
        contentTxt: t("TotalAddedVillages"),
        footTxt: t("AddNewVillage"),
      };
    case MasterNames.SUBAREA:
      return {
        image: <img src={villagemaster} alt="Village Master" />,
        contentTxt: t("TotalAddedSubareas"),
        footTxt: t("AddNewSubareas"),
      };
    case MasterNames.PHC:
      return {
        image: <img src={phcmaster} alt="PHC Master" />,
        contentTxt: t("TotalAddedPHC"),
        footTxt: t("AddNewPHC"),
      };
    case MasterNames.UPHC:
      return {
        image: <img src={phcmaster} alt="UPHC Master" />,
        contentTxt: t("TotalAddedUPHC"),
        footTxt: t("AddNewUPHC"),
      };
    case MasterNames.TALUKA:
      return {
        image: <img src={talukamaster} alt="Taluka Master" />,
        contentTxt: t("TotalAddedTalukas"),
        footTxt: t("AddNewTaluka"),
      };
    case MasterNames.SUBCENTER:
      return {
        image: <img src={subcenterImg} alt="Subcenter Master" />,
        contentTxt: t("TotalAddedSubcenter"),
        footTxt: t("AddNewSubcenter"),
      };
    case MasterNames.BANK:
      return {
        image: <img src={bankbranchmaster} alt="Branch Master" />,
        contentTxt: t("TotalAddedBanks"),
        footTxt: t("AddNewBank"),
      };

    case MasterNames.BANK_BRANCH:
      return {
        image: <img src={bankbranchmaster} alt="Branch Branch Master" />,
        contentTxt: t("TotalAddedBanks"),
        footTxt: t("AddNewBank"),
      };
    case MasterNames.PROGRAM:
      return {
        image: <img src={workCatMasterImg} alt="Program Master" />,
        contentTxt: t("TotalAddedPrograms"),
        footTxt: t("AddNewProgram"),
      };
    case MasterNames.SCHEME:
      return {
        image: <img src={workCatMasterImg} alt="Scheme Master" />,
        contentTxt: t("TotalAddedSchemes"),
        footTxt: t("AddNewScheme"),
      };
    case MasterNames.ACTIVITY:
      return {
        image: <img src={activityMasterImg} alt="Activity Master" />,
        contentTxt: t("TotalAddedActivities"),
        footTxt: t("AddNewActivity"),
      };

    case MasterNames.ROLE:
      return {
        image: <img src={userTypeMasterImg} alt="Role Master" />,
        contentTxt: t("TotalAddedRoles"),
        footTxt: t("AddNewRole"),
      };
    case MasterNames.USER:
      return {
        image: <img src={usermaster} alt="User Master" />,
        contentTxt: t("TotalAddedUsers"),
        footTxt: t("AddNewUser"),
      };
    case MasterNames.TRAINING:
      return {
        image: <img src={trainingMasterImg} alt="Training Master" />,
        contentTxt: t("TotalAddedTrainings"),
        footTxt: t("AddNewTraining"),
      };
    case MasterNames.TRAINING_CALENDAR:
      return {
        image: <img src={trainingCalendarImg} alt="Training Calendar Master" />,
        contentTxt: t("TotalTrainingsScheduled"),
        footTxt: t("AddNewTrainingScheduled"),
      };
    case MasterNames.FACULTY:
      return {
        image: <img src={facultyImg} alt="Faculty Master" />,
        contentTxt: t("TotalAddedFaculty"),
        footTxt: t("AddNewFaculty"),
      };
    default:
      return { image: "", footTxt: "" };
  }
}

function handleViewMoreClick(masterName, navigate) {
  switch (masterName) {
    case MasterNames.AREATYPE:
      navigate(`/master/${MasterTypes.AREATYPE}`);
      break;
    case MasterNames.DISTRICT:
      navigate(`/master/${MasterTypes.DISTRICT}`);
      break;
    case MasterNames.GOVERNINGBODY:
      navigate(`/master/${MasterTypes.GOVERNINGBODY}`);
      break;
    case MasterNames.CORPORATION:
      navigate(`/master/${MasterTypes.CORPORATION}`);
      break;
    case MasterNames.VILLAGE:
      navigate(`/master/${MasterTypes.VILLAGE}`);
      break;
    case MasterNames.SUBAREA:
      navigate(`/master/${MasterTypes.SUBAREA}`);
      break;
    case MasterNames.PHC:
      navigate(`/master/${MasterTypes.PHC}`);
      break;
    case MasterNames.UPHC:
      navigate(`/master/${MasterTypes.UPHC}`);
      break;
    case MasterNames.TALUKA:
      navigate(`/master/${MasterTypes.TALUKA}`);
      break;
    case MasterNames.SUBCENTER:
      navigate(`/master/${MasterTypes.SUBCENTER}`);
      break;
    case MasterNames.BANK:
      navigate(`/master/${MasterTypes.BANK}`);
      break;

    case MasterNames.BANK_BRANCH:
      navigate(`/master/${MasterTypes.BANK_BRANCH}`);
      break;
    case MasterNames.PROGRAM:
      navigate(`/master/${MasterTypes.PROGRAM}`);
      break;
    case MasterNames.SCHEME:
      navigate(`/master/${MasterTypes.SCHEME}`);
      break;
    case MasterNames.ACTIVITY:
      navigate(`/master/${MasterTypes.ACTIVITY}`);
      break;
    case MasterNames.ROLE:
      navigate(`/master/${MasterTypes.ROLE}`);
      break;
    case MasterNames.USER:
      navigate(`/master/${MasterTypes.USER}`);
      break;
    case MasterNames.TRAINING:
      navigate(`/master/${MasterTypes.TRAINING}`);
      break;
    case MasterNames.TRAINING_CALENDAR:
      navigate(`/master/${MasterTypes.TRAINING_CALENDAR}`);
      break;
    case MasterNames.FACULTY:
      navigate(`/master/${MasterTypes.FACULTY}`);
      break;
    default:
      navigate("/master");
  }
}

function handleAddMasterData(
  masterName,
  setVisible,
  setSelectedMasterType,
  setSelectedForm,
  navigate
) {
  switch (masterName) {
    case MasterNames.AREATYPE:
      setVisible(true);
      setSelectedMasterType(MasterTypes.AREATYPE);
      setSelectedForm(FORM_CONFIG.areaFields);
      break;
    case MasterNames.DISTRICT:
      setVisible(true);
      setSelectedMasterType(MasterTypes.DISTRICT);
      setSelectedForm(FORM_CONFIG.districtFields);
      break;
    case MasterNames.TALUKA:
      setVisible(true);
      setSelectedMasterType(MasterTypes.TALUKA);
      setSelectedForm(FORM_CONFIG.talukaFields);
      break;
    case MasterNames.GOVERNINGBODY:
      setVisible(true);
      setSelectedMasterType(MasterTypes.GOVERNINGBODY);
      setSelectedForm(FORM_CONFIG.governingbodyFields);
      break;
    case MasterNames.CORPORATION:
      setVisible(true);
      setSelectedMasterType(MasterTypes.CORPORATION);
      setSelectedForm(FORM_CONFIG.corporationFields);
      break;
    case MasterNames.PHC:
      setVisible(true);
      setSelectedMasterType(MasterTypes.PHC);
      setSelectedForm(FORM_CONFIG.phcFields);
      break;
    case MasterNames.UPHC:
      setVisible(true);
      setSelectedMasterType(MasterTypes.UPHC);
      setSelectedForm(FORM_CONFIG.uphcFields);
      break;
    case MasterNames.SUBCENTER:
      setVisible(true);
      setSelectedMasterType(MasterTypes.SUBCENTER);
      setSelectedForm(FORM_CONFIG.subcenterFields);
      break;
    case MasterNames.VILLAGE:
      setVisible(true);
      setSelectedMasterType(MasterTypes.VILLAGE);
      setSelectedForm(FORM_CONFIG.villageFields);
      break;
    case MasterNames.SUBAREA:
      setVisible(true);
      setSelectedMasterType(MasterTypes.SUBAREA);
      setSelectedForm(FORM_CONFIG.subareaFields);
      break;
    case MasterNames.PROGRAM:
      setVisible(true);
      setSelectedMasterType(MasterTypes.PROGRAM);
      setSelectedForm(FORM_CONFIG.programFields);
      break;
    case MasterNames.SCHEME:
      setVisible(true);
      setSelectedMasterType(MasterTypes.SCHEME);
      setSelectedForm(FORM_CONFIG.schemeFields);
      break;
    case MasterNames.ACTIVITY:
      setVisible(true);
      setSelectedMasterType(MasterTypes.ACTIVITY);
      setSelectedForm(FORM_CONFIG.activityFields);
      break;
    case MasterNames.ROLE:
      setVisible(true);
      setSelectedMasterType(MasterTypes.ROLE);
      setSelectedForm(FORM_CONFIG.roleFields);
      break;
    case MasterNames.USER:
      setVisible(true);
      setSelectedMasterType(MasterTypes.USER);
      setSelectedForm(FORM_CONFIG.userFields);
      break;
    case MasterNames.TRAINING:
      setVisible(true);
      setSelectedMasterType(MasterTypes.TRAINING);
      setSelectedForm(FORM_CONFIG.trainingFields);
      break;
    case MasterNames.TRAINING_CALENDAR:
      setVisible(true);
      setSelectedMasterType(MasterTypes.TRAINING_CALENDAR);
      setSelectedForm(FORM_CONFIG.trainingCalendarFields);
      break;
    case MasterNames.FACULTY:
      setVisible(true);
      setSelectedMasterType(MasterTypes.FACULTY);
      setSelectedForm(FORM_CONFIG.facultyFields);
      break;
    default:
      navigate("/masters");
  }
}
